// Mock data for Luma Med Global platform

export const candidates = [
  {
    id: 'cand-001',
    name: 'Dr. Sarah Mitchell',
    email: 'sarah.mitchell@email.com',
    profession: 'Registered Nurse',
    specialisation: 'Critical Care',
    country: 'United Kingdom',
    experience: 8,
    aiScore: 92,
    status: 'verified',
    videoStatus: 'completed',
    documentStatus: 'verified',
    skills: ['ICU', 'Emergency Care', 'Patient Assessment', 'Ventilator Management'],
    preferredSectors: ['Hospitals', 'Emergency Medicine'],
    matches: 12,
    interviews: 3,
    relocationStatus: 'in-progress',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah'
  },
  {
    id: 'cand-002',
    name: 'James Patterson',
    email: 'james.p@email.com',
    profession: 'Medical Doctor',
    specialisation: 'Cardiology',
    country: 'Australia',
    experience: 12,
    aiScore: 95,
    status: 'verified',
    videoStatus: 'completed',
    documentStatus: 'verified',
    skills: ['Cardiac Surgery', 'Interventional Cardiology', 'Echocardiography'],
    preferredSectors: ['Cardiology', 'Private Hospitals'],
    matches: 8,
    interviews: 5,
    relocationStatus: 'completed',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=James'
  },
  {
    id: 'cand-003',
    name: 'Emily Roberts',
    email: 'emily.roberts@email.com',
    profession: 'Registered Nurse',
    specialisation: 'Paediatrics',
    country: 'Canada',
    experience: 5,
    aiScore: 88,
    status: 'pending-review',
    videoStatus: 'completed',
    documentStatus: 'pending',
    skills: ['Paediatric Care', 'Neonatal Nursing', 'Family Education'],
    preferredSectors: ['Paediatrics', 'Community Health'],
    matches: 6,
    interviews: 1,
    relocationStatus: 'not-started',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emily'
  }
];

export const employers = [
  {
    id: 'emp-001',
    name: 'King Fahad Medical City',
    type: 'Large Hospital',
    location: 'Riyadh, Saudi Arabia',
    size: '1000+ beds',
    status: 'verified',
    activeJobs: 24,
    hiredCandidates: 45,
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=KFMC'
  },
  {
    id: 'emp-002',
    name: 'Saudi German Hospital',
    type: 'Private Hospital',
    location: 'Jeddah, Saudi Arabia',
    size: '500-1000 beds',
    status: 'verified',
    activeJobs: 18,
    hiredCandidates: 32,
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=SGH'
  },
  {
    id: 'emp-003',
    name: 'Al Mouwasat Hospital',
    type: 'Private Hospital',
    location: 'Dammam, Saudi Arabia',
    size: '200-500 beds',
    status: 'verified',
    activeJobs: 12,
    hiredCandidates: 18,
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=Mouwasat'
  }
];

export const jobs = [
  {
    id: 'job-001',
    title: 'Critical Care Nurse',
    employer: 'King Fahad Medical City',
    employerId: 'emp-001',
    location: 'Riyadh',
    department: 'ICU',
    experience: '5+ years',
    salary: 'SAR 15,000 - 20,000',
    benefits: ['Housing', 'Flight tickets', 'Health insurance', 'Annual leave'],
    description: 'Seeking experienced critical care nurses for our state-of-the-art ICU facility.',
    requirements: ['Valid nursing licence', 'ICU certification', 'English proficiency'],
    postedDate: '2025-07-15',
    applicants: 24,
    matched: 8,
    status: 'active'
  },
  {
    id: 'job-002',
    title: 'Consultant Cardiologist',
    employer: 'Saudi German Hospital',
    employerId: 'emp-002',
    location: 'Jeddah',
    department: 'Cardiology',
    experience: '10+ years',
    salary: 'SAR 35,000 - 45,000',
    benefits: ['Housing allowance', 'Flight tickets', 'Health insurance', 'Education allowance'],
    description: 'Leading private hospital seeking consultant cardiologist with interventional cardiology experience.',
    requirements: ['Board certification', 'Saudi/Arab Board', 'English & Arabic preferred'],
    postedDate: '2025-07-10',
    applicants: 12,
    matched: 5,
    status: 'active'
  },
  {
    id: 'job-003',
    title: 'Paediatric Nurse',
    employer: 'Al Mouwasat Hospital',
    employerId: 'emp-003',
    location: 'Dammam',
    department: 'Paediatrics',
    experience: '3+ years',
    salary: 'SAR 12,000 - 16,000',
    benefits: ['Accommodation', 'Annual tickets', 'Health insurance'],
    description: 'Join our paediatric team in providing excellent care for children and families.',
    requirements: ['Paediatric nursing experience', 'Valid licence', 'Good communication skills'],
    postedDate: '2025-07-18',
    applicants: 18,
    matched: 6,
    status: 'active'
  }
];

export const interviews = [
  {
    id: 'int-001',
    candidateId: 'cand-001',
    candidateName: 'Dr. Sarah Mitchell',
    employerId: 'emp-001',
    employerName: 'King Fahad Medical City',
    jobId: 'job-001',
    jobTitle: 'Critical Care Nurse',
    date: '2025-07-25',
    time: '10:00 AM',
    type: 'Video',
    status: 'scheduled',
    meetingLink: 'https://meet.lumamed.com/interview-001'
  },
  {
    id: 'int-002',
    candidateId: 'cand-002',
    candidateName: 'James Patterson',
    employerId: 'emp-002',
    employerName: 'Saudi German Hospital',
    jobId: 'job-002',
    jobTitle: 'Consultant Cardiologist',
    date: '2025-07-28',
    time: '2:00 PM',
    type: 'In-person',
    status: 'scheduled',
    location: 'Jeddah Office'
  }
];

export const aiAnalysis = {
  'cand-001': {
    videoScore: {
      communication: 92,
      confidence: 88,
      professionalism: 95,
      clarity: 90,
      overall: 92
    },
    skillsExtracted: ['ICU', 'Emergency Care', 'Patient Assessment', 'Ventilator Management', 'Critical Thinking'],
    documentVerification: {
      nursingLicence: 'verified',
      degree: 'verified',
      certifications: 'verified',
      policeCheck: 'verified',
      references: 'verified'
    },
    redFlags: [],
    recommendations: 'Excellent candidate with strong communication skills and verified credentials.'
  },
  'cand-002': {
    videoScore: {
      communication: 95,
      confidence: 93,
      professionalism: 96,
      clarity: 94,
      overall: 95
    },
    skillsExtracted: ['Cardiac Surgery', 'Interventional Cardiology', 'Echocardiography', 'Clinical Leadership'],
    documentVerification: {
      medicalLicence: 'verified',
      degree: 'verified',
      specialisation: 'verified',
      policeCheck: 'verified',
      references: 'verified'
    },
    redFlags: [],
    recommendations: 'Highly qualified specialist with excellent credentials and presentation skills.'
  }
};

export const relocationChecklist = [
  { id: 1, task: 'Obtain SCFHS Registration', status: 'completed', category: 'Licensing' },
  { id: 2, task: 'Complete Dataflow Verification', status: 'completed', category: 'Licensing' },
  { id: 3, task: 'Medical Fitness Certificate', status: 'in-progress', category: 'Medical' },
  { id: 4, task: 'Police Clearance Certificate', status: 'completed', category: 'Documents' },
  { id: 5, task: 'Visa Application', status: 'pending', category: 'Immigration' },
  { id: 6, task: 'Flight Booking', status: 'pending', category: 'Travel' },
  { id: 7, task: 'Accommodation Arrangement', status: 'pending', category: 'Housing' },
  { id: 8, task: 'Bank Account Setup', status: 'not-started', category: 'Finance' }
];

export const notifications = [
  {
    id: 'notif-001',
    type: 'interview',
    title: 'Interview Scheduled',
    message: 'Your interview with King Fahad Medical City is scheduled for 25 July at 10:00 AM',
    date: '2025-07-20',
    read: false
  },
  {
    id: 'notif-002',
    type: 'match',
    title: 'New Job Match',
    message: 'You have 3 new job matches based on your profile',
    date: '2025-07-19',
    read: false
  },
  {
    id: 'notif-003',
    type: 'document',
    title: 'Documents Verified',
    message: 'Your nursing licence has been successfully verified',
    date: '2025-07-18',
    read: true
  }
];

export const analytics = {
  'emp-001': {
    activeJobs: 24,
    totalApplicants: 156,
    matchedCandidates: 48,
    interviewsScheduled: 18,
    hires: 12,
    averageTimeToHire: 21, // days
    costPerHire: 8500, // SAR
    candidateQuality: 4.5, // out of 5
    monthlyData: [
      { month: 'Jan', hires: 3, applicants: 45 },
      { month: 'Feb', hires: 4, applicants: 52 },
      { month: 'Mar', hires: 5, applicants: 58 },
      { month: 'Apr', hires: 6, applicants: 62 },
      { month: 'May', hires: 8, applicants: 71 },
      { month: 'Jun', hires: 7, applicants: 68 },
      { month: 'Jul', hires: 12, applicants: 82 }
    ]
  }
};

export const pricingPlans = [
  {
    id: 'clinic',
    name: 'Clinic',
    type: 'Small Practices',
    price: 'SAR 2,999',
    period: '/month',
    features: [
      'Up to 5 active job postings',
      'AI-assisted candidate matching',
      'Document verification',
      'Basic analytics',
      'Email support',
      'Introductory early-access pricing'
    ],
    popular: false,
    earlyAccess: true
  },
  {
    id: 'hospital-small',
    name: 'Small Hospital',
    type: '50-200 beds',
    price: 'SAR 7,999',
    period: '/month',
    features: [
      'Up to 15 active job postings',
      'Advanced AI-assisted matching',
      'Full document verification',
      'Video interview analysis',
      'Advanced analytics dashboard',
      'Priority support',
      'Dedicated account manager',
      'Introductory early-access pricing'
    ],
    popular: true,
    earlyAccess: true
  },
  {
    id: 'hospital-large',
    name: 'Large Hospital',
    type: '500+ beds',
    price: 'SAR 19,999',
    period: '/month',
    features: [
      'Unlimited job postings',
      'AI-assisted recruitment suite',
      'Complete verification services',
      'Interview scheduling assistant',
      'ROI analytics & reporting',
      'API integration',
      'White-label options',
      '24/7 premium support',
      'Custom workflows',
      'Introductory early-access pricing'
    ],
    popular: false,
    earlyAccess: true
  },
  {
    id: 'per-hire',
    name: 'Pay Per Hire',
    type: 'Flexible Option',
    price: 'Variable',
    period: '% of first year salary',
    features: [
      'No monthly commitment',
      'All platform features',
      'Success-based pricing',
      'Full candidate support',
      'Verification included',
      'Rate varies by role (15-25%)'
    ],
    popular: false,
    earlyAccess: true
  }
];

export const faqData = [
  {
    question: 'How does the AI-assisted matching system work?',
    answer: 'Our AI-assisted system analyses candidate qualifications, experience, skills, and preferences to help match them with suitable positions. It considers factors like specialisation, location preferences, salary expectations, and cultural fit to streamline the review process.'
  },
  {
    question: 'What documents need verification?',
    answer: 'We review medical/nursing licences, degrees, certifications, police clearance certificates, and references for completeness. Our system helps identify any inconsistencies or missing documents. Note: Our review checks for completeness and does not constitute regulatory approval.'
  },
  {
    question: 'How long does the recruitment process take?',
    answer: 'Timelines vary based on role complexity and candidate availability. Our platform helps streamline the process through organised document management and efficient communication tools.'
  },
  {
    question: 'Do you assist with SCFHS registration?',
    answer: 'Yes! We provide guidance, checklists, and support throughout the SCFHS licensing process for candidates moving to Saudi Arabia.'
  },
  {
    question: 'What about visa and relocation support?',
    answer: 'We offer relocation tracking, visa guidance, and coordination assistance through our platform to help streamline the move to Saudi Arabia.'
  },
  {
    question: 'Is the platform GDPR compliant?',
    answer: 'We comply with UK GDPR and Saudi data protection regulations, ensuring all data is encrypted and securely stored.'
  }
];